import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreators from './../actions';
import Campaigns from './../components/Campaigns';
import utils from './../lib/utils';

function mapDispatchToProps(dispatch) {
  return bindActionCreators(ActionCreators, dispatch);
}

function mapStateToProps(state) {
  return {
    auth:state.auth,
    dashboard: state.dashboard,
    business: state.business,
    currentDomain: utils.getCookie('domain'),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Campaigns);
